import { YesNoDialogComponent } from './dialogs/yes-no-dialog/yes-no-dialog.component';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackbarComponent } from './snackbar/snackbar/snackbar.component';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "src/app/material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActionDialogComponent } from "./dialogs/action-dialog/action-dialog.component";
import { InfoDialogComponent } from "./dialogs/info-dialog/info-dialog.component";
import { SelectedTabComponent } from "./selected-tab/selected-tab.component";
import { TableLinksModalComponent } from "./modals/table-links-modal/table-links-modal.component";
import { DynamicFormModule } from "./dynamic-form/dynamic-form.module";
import { RecordsModule } from "../modules/records/records.module";
import { DetailButtonComponent } from "./table-components/detail-button/detail-button.component";
import { ActionButtonsComponent } from "./table-components/action-buttons/action-buttons.component";
import { ActionButtonsNoTextComponent } from "./table-components/action-buttons-no-text/action-buttons-no-text.component";
import { RatingComponent } from "./table-components/rating/rating.component";
import { TableColsFilterComponent } from "./table-cols-filter/table-cols-filter.component";
import { TableActionsComponent } from "./table-actions/table-actions.component";
import { FilterButtonsComponent } from "./filter-buttons/filter-buttons.component";
import { TableSearchComponent } from "./table-search/table-search.component";
import { TableFilterComponent } from "./table-filter/table-filter.component";
import { TranslateModule } from "../modules/translate/translate.module";
import { CheckboxComponent } from "./table-components/checkbox/checkbox.component";
import { ActionPlanDialogComponent } from "./dialogs/action-plan-dialog/action-plan-dialog.component";
import { ConfirmDialogComponent } from "./dialogs/confirm-dialog/confirm-dialog.component";
import { InterviewDetailComponent } from "./modals/interview-detail/interview-detail.component";
import { SelectedDateColumnComponent } from './selected-date-column/selected-date-column.component';
import { HelpDeskComponent } from './dialogs/help-desk/help-desk.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NotElementFoundComponent } from './not-element-found/not-element-found.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { ExpandMultiTableComponent } from './commands/expand-multi-table/expand-multi-table.component';
import { InterviewDetailsMapper } from './modals/interview-detail/interview-detail-mapper.service';
import { TruncatePipe } from './modals/interview-detail/truncate.pipe';

import { SplitAnswerPipe } from './modals/interview-detail/split-answer.pipe';
import { FeatureFlagPipe } from './featureFlags/feature-flag.pipe';
import { HighlightLettersDirective } from './directives/highlight-letters.directive';
import { CompetitorsDialogComponent } from './dialogs/competitors-dialog/competitors-dialog.component';
import { OnlineRepCommentDialogComponent } from './dialogs/online-rep-comment-dialog/online-rep-comment-dialog.component';
import { TagOnlineRepDialogComponent } from './dialogs/tag-online-rep-dialog/tag-online-rep-dialog.component';
import { CheckResponseOnlineComponent } from './table-components/rating/check-response-online/check-response-online.component';
import { SnackbarBrandErrorComponent } from './snackbar/snackbar-brand-error/snackbar-brand-error.component';
import { SnackbarORComponent } from './snackbar/snackbar-OR/snackbar-or/snackbar-or.component';
import { InterviewDetailV2Component } from './modals/interview-detail-v2/interview-detail-v2.component';
import { FilterUniqueComponent } from './filter-unique/filter-unique.component';
import { ChatbotComponent } from './chatbot/chatbot.component';

@NgModule({
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    RecordsModule,
    TranslateModule,
  ],
  declarations: [
    ActionDialogComponent,
    InfoDialogComponent,
    SelectedTabComponent,
    TableLinksModalComponent,

    DetailButtonComponent,
    ActionButtonsComponent,
    ActionButtonsNoTextComponent,
    RatingComponent,
    TableColsFilterComponent,
    TableActionsComponent,
    FilterButtonsComponent,
    TableSearchComponent,
    TableFilterComponent,
    CheckboxComponent,
    ActionPlanDialogComponent,
    YesNoDialogComponent,
    ConfirmDialogComponent,
    //  AppealDialogInfoComponent,
    InterviewDetailComponent,
    TruncatePipe,
    SplitAnswerPipe,
    SnackbarComponent,
    SelectedDateColumnComponent,
    FilterUniqueComponent,
    HelpDeskComponent,
    TopBarComponent,
    NavbarComponent,
    NotElementFoundComponent,
    VideoPlayerComponent,
    ExpandMultiTableComponent,
    //AppealDetailComponent,
    FeatureFlagPipe,
    HighlightLettersDirective,
    SnackbarBrandErrorComponent,
    TagOnlineRepDialogComponent,
    OnlineRepCommentDialogComponent,
    CheckResponseOnlineComponent,
    CompetitorsDialogComponent,
    SnackbarORComponent,
    InterviewDetailV2Component,
    ChatbotComponent
  ],
  exports: [
    YesNoDialogComponent,
    ActionDialogComponent,
    InfoDialogComponent,
    SelectedTabComponent,
    TableLinksModalComponent,
    RecordsModule,
    TableColsFilterComponent,
    TableActionsComponent,
    FilterButtonsComponent,
    TableSearchComponent,
    TableFilterComponent,
    MaterialModule,
    DynamicFormModule,
    ActionButtonsComponent,
    ActionButtonsNoTextComponent,
    SnackbarComponent,
    SelectedDateColumnComponent,
    FilterUniqueComponent,
    HelpDeskComponent,
    TopBarComponent,
    NavbarComponent,
    NotElementFoundComponent,
    VideoPlayerComponent,
    ExpandMultiTableComponent,
    HighlightLettersDirective,
    TruncatePipe,
    SplitAnswerPipe,
    FeatureFlagPipe,
    TagOnlineRepDialogComponent,
    RatingComponent,
    DetailButtonComponent,
    CheckboxComponent,
    ActionPlanDialogComponent,
    ConfirmDialogComponent,

    InterviewDetailComponent,
    CheckResponseOnlineComponent,
    InterviewDetailV2Component,
    ChatbotComponent
  ],

  // entryComponents: [
  //   ActionDialogComponent,
  //   InfoDialogComponent,
  //   TableLinksModalComponent,
  //   SnackbarComponent,
  //   HighlightLettersDirective,
  //   TruncatePipe,
  //   SplitAnswerPipe,
  //   FeatureFlagPipe,
  //   RatingComponent,
  //   DetailButtonComponent,
  //   CheckboxComponent,
  //   ActionPlanDialogComponent,
  //   ConfirmDialogComponent,

  //   InterviewDetailComponent,

  //   CheckResponseOnlineComponent,
  //   InterviewDetailV2Component
  // ],
  providers: [
    InterviewDetailsMapper,
    { provide: MAT_SNACK_BAR_DATA, useValue: {} }
  ]
})
export class SharedModule { }
